import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { produzentenByNrSelector, produzentenSelector } from 'store/lookups/selector';

interface ProduzentByNrProps {
    label: string;
    disabled: boolean;
    value: number | null;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValue: number) => void;
}

export const ProduzentByNr: React.FC<ProduzentByNrProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const produzenten = useSelector(produzentenSelector);
    const produzentenByNr = useSelector(produzentenByNrSelector);

    const options = React.useMemo(() => {
        const o = produzenten
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((p) => ({
                value: p.nr.toString(),
                label: p.name,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [produzenten, allowEmpty]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: produzentenByNr[value]?.name || value.toString(),
                          }
                        : null
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value ? parseInt(option?.value, 10) || 0 : 0);
                }}
                placeholder={renderLabel === 'placeholder' ? 'Produzent' : ''}
            />
        </>
    );
};
